import { useEffect, useContext } from "react";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Stack, Switch, Box, Typography } from "@mui/material";
import { BorderColor, Visibility } from "@mui/icons-material";
import { useHistory, useLocation } from "react-router-dom";
import { Index as Form} from "./form/Index";
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from "../../../../core/request/API";
import { env, domain } from "../../../../core/Env";
import { DirectTabLoader } from "../../../../core/loader/DirectTabLoader";
import { SnakeLoader } from "../../../../core/loader/SnakeLoader";
import { EmptyList } from "../../../../core/global/realproperty/Index";
import { Confirmation } from "../../../../core/global/realproperty/Index";
import { SuccessMsg } from "../../../../core/global/SuccessMsg";
import Currency from 'react-currency-format';

export const Index = () => {
    const { realproperty_state, tool_state } = useContext(ToolContext);
    const { prptyInqrs, confirmation, status, statusStyles } = realproperty_state;
    const method = new URLSearchParams(window.location.search).get('method')
    // const style = statusStyles.data[status];
    const nav = useHistory();
    const location = useLocation();

    const handleGoToForm = (id) => {
        nav.push(`${window.location.pathname}?method=update&pid=${window.btoa(`prm_${JSON.parse(id)}`)}`)
    }
 
    const __init = async () => {
        try {
            prptyInqrs.set((p) => ({ ...p, loader: true }))   
            const res_list = await rqx.get(`<<tool>>/${env()}/propertyListing/read_properties_inquiries`, { company_id: tool_state.__SESSION.data.uaccess[0].company_id });
            prptyInqrs.set((p) => ({ ...p, list: res_list, loader: false }))   
        } catch (error) {
            console.error(error);
        }
    }

    const cleanJsonNumbers = (jsonStr) => {
        return JSON.stringify(
            Object.fromEntries(
                Object.entries(JSON.parse(jsonStr)).map(([k, v]) => [
                    k,
                    typeof v === 'string' && v.includes(',')
                    ? parseInt(v.replace(/,/g, ''), 10)
                    : v,
                ])
            )
        );
    }

    const seeProperty = async (comp_id, web_id, offer_type, list_id) => {
        let ssoUrls = `${domain('shp').url}/psl/ws/realproperty/${window.btoa(`${comp_id}`)}_${window.btoa(`${web_id}`)}?type=property-${offer_type === 1 ? 'buy' : 'rent' }&view=${window.btoa(list_id)}`
        await DirectTabLoader('ShpWN', ssoUrls)
    }

    const handleStatusModal = (v, active, id) => {
        confirmation.set((p) => ({ ...p, statusConfirmation: v === 'open' }))
        status.set((p) => ({...p, statusId: id, statusData: active }))
    }

    const handleUpdateStatus = async () => {
        confirmation.set((p) => ({ ...p, statusLoader: true }))
        try {
            const body = {
                id: status.data.statusId,
                user_id: tool_state.userId.data,
                active: status.data.statusData === 1 ? 0 : 1
            }
            const res = await rqx.post(`<<tool>>/${env()}/propertyListing/update_inquiry_active`, body)
            if (res.message === 'success') {
                status.set((p) => ({...p, isStatusUpdated: true }))
                prptyInqrs.set((p) => ({ 
                    ...p, list: p.list.map(v => v.property_inquiry_id === status.data.statusId ? { ...v, active: status.data.statusData === 1 ? 0 : 1} : v)
                }))
                confirmation.set((p) => ({ ...p, statusLoader: false, statusConfirmation: false }))
            }
        } catch (err) {
            console.error("Failed to update status", err);
        } 
    }

    const getStatus = (v) => {
        if (v.property_inquiry_status === 4) return 'Deal Closed';
        if (v.user_property_requirement_id) return 'Requirements Saved';
        if (v.appointment_status === 1) return 'Appointment Scheduled';
        if (v.appointment_status === 2) return 'Appointment Completed';
        if (v.appointment_status === 3) return 'Appointment Cancelled';
        if (v.property_inquiry_status === 1) return 'For Inquiry';
        if (v.property_inquiry_status === 2) return 'Declined';
        if (v.property_inquiry_status === 3) return 'Approved';
        return 'Unknown Status';
    };

    useEffect(() => {
        if (location.state?.shouldReload) {
            __init()
        }
        // eslint-disable-next-line
    }, [location.state]);

    useEffect( () => {
        __init()
        // eslint-disable-next-line
    }, [])

    return (
        <Box mt="1rem">
            { prptyInqrs.data.loader ?
                <Box display="flex" justifyContent="center" mt="4rem"><SnakeLoader size="12px" bg="#11783C" distance="8px" /></Box> 
            :
                prptyInqrs.data.list.length === 0 ? 
                    <EmptyList text="No inquiries have been received yet."/>
                :
                    <>
                        {   method === null ?  
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 700 }}>
                                    <TableHead sx={(theme) => ({ bgcolor: theme.palette.primary.main })}>
                                        <TableRow>
                                            <TableCell align="center" sx={{ color: "white", width: "4rem", }}>No.</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Name</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Property Type</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Offer type</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Price</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Status</TableCell>
                                            <TableCell align="center" sx={{ color: "white", width: "8.5rem" }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        { prptyInqrs.data.list?.map((v, k) => (
                                            <TableRow key={k}>
                                                <TableCell component="th" scope="row" align="center">{prptyInqrs.data.list.length - k}</TableCell>
                                                <TableCell align="left">{v.full_name}</TableCell>
                                                <TableCell align="left">{v.property_type}</TableCell>
                                                <TableCell align="left">{v.offer_type === 1 ? 'Sell' : v.offer_type === 2 ? 'Rent' : 'N/A'}</TableCell>
                                                <TableCell align="left"> 
                                                    {v.offer_type === 1 && <Typography color="#757575">₱&nbsp;<Currency displayType={'text'} thousandSeparator={true} value={parseFloat(JSON.parse(cleanJsonNumbers(v.price)).price).toFixed(2)} /></Typography>}
                                                    {v.offer_type === 2 &&
                                                        <Box display="flex" alignItems="center" gap={2} color="#4CAF50">
                                                            <Box display="flex" alignItems="center" flexDirection="column">Monthly <Box fontSize={14} color="#e23a08">₱&nbsp;
                                                                <Currency displayType={'text'} thousandSeparator={true} value={parseFloat(JSON.parse(cleanJsonNumbers(v.price)).monthly).toFixed(2)} />
                                                            </Box>
                                                            </Box>
                                                            <Box display="flex" alignItems="center" flexDirection="column"> Yearly <Box fontSize={14} color="#52D3D8">₱&nbsp;
                                                                <Currency displayType={'text'} thousandSeparator={true} value={parseFloat(JSON.parse(cleanJsonNumbers(v.price)).yearly).toFixed(2)} />
                                                            </Box>
                                                            </Box>
                                                        </Box>
                                                    }
                                                </TableCell>
                                                <TableCell align="left">{
                                                    <Box px="0.5rem" sx={{ borderRadius: "8px", width: "fit-content", bgcolor: statusStyles.data[getStatus(v)].bgcolor, color: statusStyles.data[getStatus(v)].color }}>
                                                        {getStatus(v)}
                                                    </Box>
                                                }</TableCell>
                                                <TableCell align="center">
                                                    <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
                                                        { v.active === 0 ?
                                                            <>
                                                                <Visibility fontSize="small" sx={{ color: "grey", cursor: "not-allowed" }}/>
                                                                <BorderColor fontSize="small" sx={{ color: "grey", cursor: "not-allowed" }}/>
                                                            </>  
                                                        :
                                                            <>                                                            
                                                                <Visibility onClick={() => seeProperty(v.company_id, v.website_id, v.offer_type, v.listing_id)} fontSize="small" sx={{ cursor: "pointer", transition: "0.25s" ,':hover': { color: "grey" } }}/>
                                                                <BorderColor onClick={() => handleGoToForm(v.property_inquiry_id)} fontSize="small" sx={{ cursor: "pointer", transition: "0.25s" ,':hover': { color: "grey" } }}/>
                                                            </>
                                                        }
                                                        <Switch /*disabled={v.status === 0}*/ onClick={() => handleStatusModal('open', v.active, v.property_inquiry_id)} size="small" checked={v.active === 1}/>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow> 
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        :
                            method === 'update' ? <Form/>
                        :
                            <Box>404 Page not found!</Box>
                        }
                </>
            }
            { confirmation.data.statusConfirmation && <Confirmation isOpen={confirmation.data.statusConfirmation} cancel={() => handleStatusModal('close')} send={() => handleUpdateStatus()} disabled={confirmation.data.statusLoader} status={status.data.statusData} dsbldTxt='You won’t be able to update this inquiry unless you enable it again.' enbldTxt='You can update the inquiry information.' dsbldTitle = "Disabled this Inquiry?" enbldTitle = "Enabled this Inquiry?"/> }
            { status.data.isStatusUpdated && <SuccessMsg open={status.data.isStatusUpdated} setOpen={(v) => status.set(p => ({ ...p, isStatusUpdated: v }))} message="Success" bgcolor="#d2f9e2" hideDuration={null}/> }
        </Box>
    )
}
